import '../Styles/Sass/UserCard.scss';

function UserCard(props){


  const renderUploads = () => {
    if (props.uploads) {
      console.log(props.uploads);
      const userUploads = props.uploads;
      const imageRender = userUploads.map(upload => {
        return <img className='usercard__images' src={`${upload.url}`} alt={`${upload.name}`} />
      });
      return imageRender;
    }
  }

  return(
    <li key={props.userId} className='usercard'>
      <h4 className='usercard__title'>{props.name}</h4>
      <p className='usercard__text'>
        {
          props.job === '' ?
            'Needs Update' :
            props.job
        }
      </p>
      <p className='usercard__text'>{props.email}</p>
      <button
        onClick={() => props.verifyUser(props.userId, 'verified', props.verified, props.job)}
      >
        {
          props.verified ?
            'Verified' :
            'Needs Verification'
        }
      </button>
      <button
        onClick={() => props.verifyUser(props.userId, 'whimis', props.whimis, props.job)}
      >
        {
          props.whimis ?
            'WHIMIS Verified' :
            'WHIMIS Needs Verification'
        }
      </button>
      {
        props.job === 'cleaner' ?
          <button
            onClick={() => props.verifyUser(props.userId, 'policecheck', props.policecheck, props.job)}
          >
            {
              props.policecheck ?
                'Police Verified' :
                'Police Needs Verification'
            }
          </button> :
          <></>
      }
      {renderUploads()}
    </li>
  );
}

export default UserCard;